import { createMuiTheme } from '@material-ui/core/styles'

export const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#3484A6',
        },
        secondary: {
            main: '#secondary',
        },
    },

    typography: {
        fontFamily: [
            "游ゴシック Medium",
            "游ゴシック体",
            "Yu Gothic Medium",
            "YuGothic",
            "ヒラギノ角ゴ ProN",
            "Hiragino Kaku Gothic ProN",
            "メイリオ",
            "Meiryo",
            "ＭＳ Ｐゴシック",
            "MS PGothic",
            "sans-serif",
        ].join(','),

        h1: {
            fontSize: 24,
            fontWeight: '600',
        },
        h2: {
            fontSize: 18,
            fontWeight: '700',
            padding: '0.4em',

        },
        body1: {
            fontSize: 14,
            fontWeight: '300',
        }

    },
});

export default theme;